import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'percentage'})

export class PercentagePipe implements PipeTransform {
	transform(input: number, decimals: number): string {
		return (input * 100).toFixed(decimals) + '%';
	}
}
